<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import api from "../../../services/api";
import PersonDetails from "../../../components/persons/person-details";
import PersonForm from "../../../components/persons/person-form";
import {dateToString} from "@/helpers/utils";
import {Person} from "@/services/models";

export default {
  page: {
    title: "Personnes",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    PersonForm,
    PersonDetails,
    Layout,
    PageHeader,
  },
  data() {
    const canEdit = !!JSON.parse(localStorage.getItem('user')).roles.find((v) => v.name === 'admin');

    return {
      title: "Personnes",
      items: [
        {
          text: "Personnes",
          active: true
        },
        {
          text: "Liste",
          active: true
        }
      ],
      canEdit,
      modalTitle: '',
      selectedPerson: null,
      isBusy: false,
      displayDetails: false,
      displayEditForm: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "last_name,first_name",
      sortDesc: false,
      fields: [
        {key: "last_name", sortable: true, label: 'Nom'},
        {key: "first_name", sortable: true, label: 'Prénom'},
        {key: "surname", sortable: true, label: 'Surnom'},
        {key: "dates", sortable: false},
        {key: "actions", sortable: false, class: 'text-center'},
      ],
      data: []
    };
  },
  mounted() {
    this.myProvider();
  },
  methods: {
    myProvider() {
      this.isBusy = true;

      return api.getModels(Person, {
        params: {
          page: this.currentPage,
          length: this.perPage,
          filter: this.filter,
          sortBy: this.sortBy,
          sortDir: (this.sortDesc ? 'desc' : 'asc'),
          with: 'birth_date,death_date'
        },
        identifier: 'provider'
      }).then((response) => {
        this.data = response.data.data;
        this.totalRows = response.data.total;
      }).catch(() => {
        this.data = [];
        this.totalRows = 0;
      }).finally(() => {
        this.isBusy = false;
      });
    },
    hideModal() {
      this.displayDetails = false;
      this.displayEditForm = false;
      this.selectedPerson = null;
      this.modalTitle = '';

      this.$bvModal.hide('modal-details');
      this.myProvider();
    },
    showDetails(item) {
      this.displayDetails = true;
      this.displayEditForm = false;
      this.selectedPerson = item;
      this.modalTitle = `${item.first_name} ${item.last_name}`;
    },
    showEditForm(item) {
      this.displayDetails = false;
      this.displayEditForm = true;
      this.selectedPerson = item;
      this.modalTitle = `${item.first_name} ${item.last_name}`;
    },
    formatDates(item) {
      let dateFull = dateToString(item.birth_date);

      if (item.death_date)
        dateFull += (dateFull !== '' ? ' - ' : '') + dateToString(item.death_date);

      return dateFull;
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.active === 0) return 'table-danger'
    },
    reset() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    }
  },
  watch: {
    currentPage() {
      this.myProvider();
    },
    filter() {
      this.reset();
    },
    sortBy() {
      this.reset();
    },
    sortDesc() {
      this.reset();
    },
    perPage() {
      this.reset();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Afficher :
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;enregistrements
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-8">
                <div id="tickets-table_filter" class="dataTables_filter text-right">
                  <label class="d-inline-flex align-items-center">
                    Recherche :
                    <b-form-input v-model="filter" type="search" placeholder="Recherche..."
                                  class="form-control-sm w-auto"></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table ref="pages_table" :items="data" :fields="fields" :busy="isBusy" striped :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc" stacked="sm" small :tbody-tr-class="rowClass">
                <template #cell(last_name)="data">
                  <strong>{{ data.item.last_name }}</strong>
                  <span v-if="data.item.birth_name"> né(e) {{ data.item.birth_name }}</span>
                </template>

                <template #cell(dates)="data">
                  {{ formatDates(data.item) }}
                </template>

                <template #cell(actions)="data">
                  <ul class="list-inline font-size-20 contact-links mb-0">
                    <li class="list-inline-item text-info">
                      <a v-b-modal.modal-details @click="showDetails(data.item)" title="Afficher">
                        <i class="bx bx-show"></i>
                      </a>
                    </li>
                    <li v-if="canEdit" class="list-inline-item text-warning">
                      <a v-b-modal.modal-details @click="showEditForm(data.item)" title="Modify">
                        <i class="bx bx-pencil"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="float-end">
                  <strong>{{ totalRows }}</strong> enregistrements
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-details" :title-html="this.modalTitle" centered hide-footer size="xl" title-class="font-18"
             @hide="hideModal">
      <person-details v-if="displayDetails" :person="this.selectedPerson"></person-details>

      <template v-if="canEdit">
        <person-form v-if="displayEditForm" :person="this.selectedPerson" v-on:cancel="hideModal"
                     v-on:submitted="hideModal"></person-form>
      </template>
    </b-modal>
  </Layout>
</template>